export default {
  colors: {
    background: '#fff',
  }
};
